import { render, staticRenderFns } from "./RemoteVanSelect.vue?vue&type=template&id=57738322&scoped=true&"
import script from "./RemoteVanSelect.vue?vue&type=script&lang=js&"
export * from "./RemoteVanSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57738322",
  null
  
)

export default component.exports